module.exports = __webpack_public_path__ + "img/sup_kyc_8.df91c62b.jpg";